import { ExternalCalendarEventPreview } from '@griply/types';

export type CalendarEventRowStateOptions = {
  isLoadingDetails?: boolean;
  preview?: ExternalCalendarEventPreview;
};

export type CalendarEventRowState = {
  isLoadingGuests: boolean;
  isLoadingDescription: boolean;
  isLoadingLocation: boolean;
  isLoadingVideoCall: boolean;
  // read-only surfaces drop the section; the editable form keeps an empty input to add one
  hasGuests: boolean;
  hasDescription: boolean;
};

// Which rows the detail fetch still has to answer; a field the list omitted skeletons as before.
export const getCalendarEventRowState = ({
  isLoadingDetails,
  preview,
}: CalendarEventRowStateOptions): CalendarEventRowState => {
  const hasGuests = preview?.guestCount !== 0;
  const hasDescription = preview?.hasDescription !== false;

  return {
    // the count settles whether to show the row; the names and RSVPs are still getEvent-only
    isLoadingGuests: !!isLoadingDetails && hasGuests,
    isLoadingDescription: !!isLoadingDetails && hasDescription,
    isLoadingLocation: !!isLoadingDetails && preview?.location === undefined,
    isLoadingVideoCall:
      !!isLoadingDetails && preview?.videoCallUrl === undefined,
    hasGuests,
    hasDescription,
  };
};

// the merged list, not raw guests — an organizer Outlook omitted is still a row worth showing
export const getCalendarEventGuestsVisible = (
  rowState: CalendarEventRowState,
  guestListLength: number,
): boolean =>
  rowState.hasGuests && (!!guestListLength || rowState.isLoadingGuests);

export const getCalendarEventDescriptionVisible = (
  rowState: CalendarEventRowState,
  description?: string | null,
): boolean =>
  rowState.hasDescription && (!!description || rowState.isLoadingDescription);
